import { FormHelperText } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { normalizeTo, removeSeconds } from 'src/commons/temporalHelpers'

import SimpleDatePicker from './SimpleDatePicker'

import { IDateTimeRange } from '.'

interface IProps {
  className?: string
  clearLabel?: string
  clearable?: boolean
  disableFuture?: boolean
  disabled?: boolean
  error?: { from: boolean; to: boolean }
  forceEnd?: (m: Temporal.ZonedDateTime) => Temporal.ZonedDateTime
  helperText?: React.ReactNode
  maxDate?: Temporal.ZonedDateTime
  maxDateMessage?: string
  minDate?: Temporal.ZonedDateTime
  onChange: (dateRange: IDateTimeRange) => void
  startDisabled?: boolean
  sx?: { [key: string]: number } | undefined
  value: IDateTimeRange
  withTime?: boolean
}

const DateRangePicker = (props: IProps) => {
  const {
    value,
    onChange,
    disableFuture,
    clearable,
    error = { from: false, to: false },
    className,
    withTime,
    helperText,
    disabled,
    startDisabled,
    forceEnd,
    minDate,
    maxDate,
    maxDateMessage,
    sx,
  } = props
  const { t } = useTranslation()

  const getEndDate = (from: any) => {
    if (!forceEnd) {
      return value.to || null
    }
    return (from && forceEnd(from)) || null
  }
  return (
    <div className={className}>
      <SimpleDatePicker
        disabled={disabled || startDisabled}
        label={t('From')}
        maxDate={value.to || maxDate}
        value={value.from || undefined}
        onChange={(d?: Temporal.ZonedDateTime) => {
          let dateTime
          if (d !== undefined) {
            dateTime = withTime ? removeSeconds(d) : d.startOfDay()
          }
          if (forceEnd) {
            onChange({
              ...value,
              from: dateTime,
              to: getEndDate(dateTime) || undefined,
            })
          } else {
            onChange({ ...value, from: dateTime })
          }
        }}
        disableFuture={disableFuture}
        clearable={clearable}
        error={error.from}
        withTime={withTime}
        minDate={minDate}
        maxDateMessage={maxDateMessage}
        inputProps={{ 'data-testid': 'date-from-field' }}
        sx={sx}
      />
      <SimpleDatePicker
        disabled={disabled || !!forceEnd}
        label={t('To')}
        minDate={value.from || minDate}
        value={getEndDate(value.from) ?? undefined}
        onChange={(d?: Temporal.ZonedDateTime) => {
          let dateTime
          if (d !== undefined) {
            dateTime = withTime ? removeSeconds(d) : normalizeTo(d)
          }
          onChange({ ...value, to: dateTime })
        }}
        disableFuture={disableFuture}
        clearable={clearable}
        error={error.to}
        withTime={withTime}
        maxDate={maxDate}
        maxDateMessage={maxDateMessage}
        inputProps={{ 'data-testid': 'date-to-field' }}
        sx={sx}
      />
      <div style={{ display: error.from || error.to ? 'block' : 'none' }}>
        <FormHelperText component="div" error={error.from || error.to}>
          {helperText}
        </FormHelperText>
      </div>
    </div>
  )
}

export default DateRangePicker
